import { render } from "./CheckoutButton.vue?vue&type=template&id=5be5f21d&scoped=true&ts=true"
import script from "./CheckoutButton.vue?vue&type=script&lang=ts"
export * from "./CheckoutButton.vue?vue&type=script&lang=ts"

import "./CheckoutButton.vue?vue&type=style&index=0&id=5be5f21d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be5f21d"]])

export default __exports__